import { defineComponent, reactive, watch, ref, nextTick, computed } from 'vue';
import { EnvironmentOutlined } from '@ant-design/icons-vue';
import { LoginService } from '@/services/login.service';
import { UserService } from '@/services/user.service';
import { useService } from '@kaokei/use-vue-service';
import VCode from '@/components/VCode.vue';
import { logger, setToken, StoreLoginUrlName } from '@/utils';
import EventBusItemDetail from '@/eventBus/itemDetail';
import { useRoute } from 'vue-router';
export default defineComponent({
  name: 'LoginDialogAccount',
  components: {
    VCode: VCode,
    EnvironmentOutlined: EnvironmentOutlined
  },
  props: {
    platform: {
      type: String,
      default: ''
    },
    itemData: {
      type: Object
    },
    accountText: {
      type: String,
      default: ''
    },
    passwdText: {
      type: String,
      default: ''
    }
  },
  setup: function (props) {
    var route = useRoute();
    var userService = useService(UserService);
    var loginService = useService(LoginService);
    var formRef = ref();
    var extraForgetTips = ref(false);
    var formState = reactive({
      account: '',
      password: ''
    });
    var formRules = computed(function () {
      return {
        account: [{
          required: true,
          message: props.accountText || '请输入账号',
          trigger: 'blur'
        }],
        password: [{
          required: true,
          message: props.passwdText || '请输入密码',
          trigger: 'blur'
        }]
      };
    });
    var onSubmit = function () {
      if (!formRef.value) return;
      var hasStoreFlag = props.platform && route.meta.storeLoginUrl;
      formRef.value.validate().then(function () {
        var xhrObj = props.platform ? loginService.otherPlatformLoginByAccount(formState.account.trim(), formState.password, props.platform) : loginService.loginByAccount(formState.account.trim(), formState.password);
        return xhrObj.then(function (res) {
          setToken(res.token);
          return userService.initUserInfo().then(function () {
            loginService.hideLoginDialog();
            loginService.queryGoToEnvCheckDialog();
            EventBusItemDetail.emit('login-success');
            if (hasStoreFlag) {
              window.localStorage.setItem(StoreLoginUrlName, window.location.href);
            }
            // 账密登录的时候清除三方登录记录的链接地址
            if (!props.platform) {
              window.localStorage.removeItem(StoreLoginUrlName);
            }
          });
        });
      }).catch(function (e) {
        logger.debug('提交登录表单失败 => ', e);
      });
    };
    // 监听登录弹窗是否关闭
    watch(function () {
      return loginService.visible;
    }, function (visible) {
      if (!visible) {
        formRef.value.resetFields();
        extraForgetTips.value = false;
      }
    });
    watch(function () {
      return props.itemData;
    }, function (itemData) {
      extraForgetTips.value = ['ItemApply', 'ItemDetail'].includes(route.name) && (itemData === null || itemData === void 0 ? void 0 : itemData.accountGenerateType) === 2;
    }, {
      immediate: true
    });
    EventBusItemDetail.on('refill-login-info', function (data) {
      formState.account = data.account;
      formState.password = data.password;
      extraForgetTips.value = true;
    });
    var showGetAccountDialog = function () {
      loginService.hideLoginDialog();
      nextTick(function () {
        loginService.toggleGetAccountVisible(true);
      });
    };
    return {
      labelCol: {
        span: 0
      },
      wrapperCol: {
        span: 24
      },
      formRef: formRef,
      formState: formState,
      formRules: formRules,
      onSubmit: onSubmit,
      loginService: loginService,
      extraForgetTips: extraForgetTips,
      showGetAccountDialog: showGetAccountDialog
    };
  }
});